
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"fill":"#2c2c30","d":"M-2061.864-1779.756a1.473 1.473 0 00-1.044.427l-8.423 8.422-.023.023a1.445 1.445 0 00-.374.61 5.883 5.883 0 00-.374 3.026.751.751 0 00.595.594 5.465 5.465 0 002.2-.107 5.315 5.315 0 00.823-.267 1.47 1.47 0 00.61-.381l.023-.023 8.431-8.422a1.684 1.684 0 00-.137-2.37l-.976-.976a1.909 1.909 0 00-1.166-.557h-.16zm-.008 1.463c-.005.005.119-.048.3.13.325.328.654.652.983.976.178.178.124.3.13.3l-.488.488-1.4-1.41zm-1.517 1.517l1.4 1.41-6.891 6.89c.016-.023-.074.053-.183.1a3.952 3.952 0 01-.595.191 4.691 4.691 0 01-1.037.114 4.676 4.676 0 01.114-1.029 4 4 0 01.2-.6c.035-.082.066-.133.069-.145zm-13.172.435a2.45 2.45 0 00-2.439 2.439v11.22a2.45 2.45 0 002.439 2.439h11.221a2.45 2.45 0 002.439-2.439v-7.073a.732.732 0 10-1.464 0v7.073a.958.958 0 01-.976.976h-11.22a.958.958 0 01-.976-.976v-11.22a.958.958 0 01.976-.976h8.049a.732.732 0 100-1.464z"}})])])
          )
        }
      }
    